import { Exclude, Type } from 'class-transformer';
import { IsDefined, IsInt, IsString, Length } from 'class-validator/decorator/decorators';

export class NpsSurveyQuestionCreateDto {
  @Exclude()
  id?: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  npsSurveyId: number;

  @IsDefined()
  @IsString()
  @Length(1, 100)
  pieCategory: string;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  sequence: number;

  @IsDefined()
  @IsString()
  @Length(1, 500)
  content: string;
}
